/**
 * Encode/decode deal-finder calculator preload for /property/:id?dealCalc=...
 */

export function encodeDealFinderCalcQuery(metrics) {
  if (!metrics || metrics.presentValue == null || metrics.homeArea == null) return "";
  if (metrics.marketValuePerSqftComps == null || metrics.costPerSqft == null) return "";

  const payload = {
    presentValue: Number(metrics.presentValue),
    homeArea: Number(metrics.homeArea),
    loanAmount:
      metrics.loanAmountForCalc != null
        ? Number(metrics.loanAmountForCalc)
        : Number(metrics.presentValue),
    currentRental:
      metrics.monthlyRent != null ? Number(metrics.monthlyRent) : 0,
    renovationTier: Math.round(Number(metrics.costPerSqft) || 0),
    marketValuePerSqft: Number(metrics.marketValuePerSqftComps) || 0,
    investorType: Math.round(Number(metrics.investorReturnRate) || 15),
    rentalPeriod: Math.round(Number(metrics.rentalPeriodMonths) || 18),
    guaranteedReturnPct: Math.round(Number(metrics.ownerReturnRate) || 10),
    upfrontPaymentPct: Math.round(Number(metrics.upfrontPaymentPct) || 30),
    paymentParts: Math.round(Number(metrics.paymentParts) || 4),
  };

  try {
    return btoa(JSON.stringify(payload));
  } catch {
    return "";
  }
}

export function decodeDealFinderCalcQuery(encoded) {
  if (!encoded || typeof encoded !== "string") return null;
  try {
    const o = JSON.parse(atob(encoded));
    if (o.presentValue == null || o.homeArea == null) return null;
    return {
      presentValue: o.presentValue,
      homeArea: o.homeArea,
      loanAmount: o.loanAmount ?? o.presentValue,
      currentRental: o.currentRental ?? 0,
      renovationTier: o.renovationTier ?? 200,
      marketValuePerSqft: o.marketValuePerSqft ?? 0,
      investorType: o.investorType ?? 15,
      rentalPeriod: o.rentalPeriod ?? 18,
      guaranteedReturnPct: o.guaranteedReturnPct ?? 10,
      upfrontPaymentPct: o.upfrontPaymentPct ?? 30,
      paymentParts: o.paymentParts ?? 4,
      hasPool: "no",
      addAreaCheckbox: false,
      extraArea: 0,
      extraAreaTier: 400,
    };
  } catch {
    return null;
  }
}
